document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cards-scroller]').forEach((scroller) => {
    scroller.addEventListener('scroll', () => {
      const isAtEnd =
        scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth;
      scroller.style.setProperty(
        '--card-scroller-can-scroll-right',
        isAtEnd ? '0' : '1'
      );
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let scrollerPositions = {};
  const scrollerItems = {};

  document.querySelectorAll('[data-cards-scroller-btn]').forEach((el) => {
    el.addEventListener('click', () => {
      const id = el.getAttribute('data-controls');
      const action = el.getAttribute('data-cards-scroller-btn');
      const scroller = document.querySelector(`[data-cards-scroller="${id}"]`);
      const items = scroller.querySelectorAll('[data-card]');
      const itemsCount = items.length;
      const scrollerWidth = scroller.getBoundingClientRect().width;

      console.log(id);
      console.log(action);

      // get all item positions
      if (typeof scrollerPositions[id] === 'undefined') {
        scrollerPositions[id] = [];
        scroller.querySelectorAll('[data-card]').forEach((item) => {
          scrollerPositions[id].push(
            Math.round(
              item.getBoundingClientRect().left -
                scroller.getBoundingClientRect().left
            )
          );
        });
      }

      // define the current item
      if (typeof scrollerItems[id] === 'undefined') {
        scrollerItems[id] = 0;
      }

      // compare the scroll position to the item position
      for (i = scrollerPositions[id].length - 1; i >= 0; i--) {
        if (
          scrollerPositions[id][i] + 5 >=
          parseFloat(scroller.getAttribute('data-scrollLeft'))
        ) {
          scrollerItems[id] = i;
        }
      }

      // next or prev item
      if (action === 'next') {
        scrollerItems[id]++;
        if (scrollerItems[id] >= itemsCount) {
          scrollerItems[id] = 0;
        }
      } else {
        scrollerItems[id]--;
        console.log(scrollerItems[id]);
        if (scrollerItems[id] < 0) {
          scrollerItems[id] = itemsCount - 1;
        }
      }

      // scroll to the new current item
      const item = items[scrollerItems[id]];
      scroller.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      return false;
    });
  });

  // update the scroll position on each scroller so it's easy to access
  document.querySelectorAll('[data-cards-scroller]').forEach((el) => {
    el.setAttribute('data-scrollLeft', 0);

    el.addEventListener(
      'scroll',
      (event) => {
        el.setAttribute('data-scrollLeft', el.scrollLeft);

        const id = el.getAttribute('data-cards-scroller');

        // Hide or show nav buttons based on scroll position
        const nextBtn = document.querySelector(
          `[data-controls="${id}"][data-cards-scroller-btn="next"]`
        );
        const prevBtn = document.querySelector(
          `[data-controls="${id}"][data-cards-scroller-btn="prev"]`
        );

        const isAtStart = el.scrollLeft <= 0;
        const isAtEnd =
          Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth;

        // console.log(isAtStart);
        // console.log(isAtEnd);
        // console.log('---');

        if (nextBtn) nextBtn.disabled = isAtEnd;
        if (prevBtn) prevBtn.disabled = isAtStart;
      },
      { passive: true }
    );
  });

  window.addEventListener('resize', function (e) {
    scrollerPositions = {};
  });
});

// Show .cards-scroll__controls only when there is horizontal overflow
// and the device is NOT touch-capable. Run on load and on resize.
(function () {
  const isTouch = () =>
    'ontouchstart' in window ||
    (navigator.maxTouchPoints || 0) > 0 ||
    (navigator.msMaxTouchPoints || 0) > 0;

  // Loops through all cards scrollers and matches their controls by id
  const updateAllControlsVisibility = () => {
    document.querySelectorAll('[data-cards-scroller]').forEach((scroller) => {
      // Try to get the scroller id (fallback to its data attribute if needed)
      const id = scroller.getAttribute('data-cards-scroller');
      if (!id) return;
      const controls = document.querySelector(
        `[data-cards-scroller-controls="${id}"]`
      );

      if (!controls) return;

      const hasOverflowX = scroller.scrollWidth - scroller.clientWidth > 1;
      const show = hasOverflowX && !isTouch();
      controls.style.display = show ? '' : 'none';
    });
  };

  // Initial check + after all assets load (images can change width)
  updateAllControlsVisibility();
  document.addEventListener('load', updateAllControlsVisibility);
  window.addEventListener('resize', updateAllControlsVisibility);
})();
